// extracted by mini-css-extract-plugin
export default {"search":"risks_search__WjWnT","fieldList":"risks_fieldList__Mqxo9","field":"risks_field__fX0NJ","count":"risks_count__NvWUU","list":"risks_list__6WdhX"};